module.exports = __webpack_public_path__ + "static/media/bender-face-2.8aa43fd5.png";